import { render, staticRenderFns } from "./NewLogin2.vue?vue&type=template&id=8b901ae4"
import script from "./NewLogin2.vue?vue&type=script&lang=js"
export * from "./NewLogin2.vue?vue&type=script&lang=js"
import style0 from "./NewLogin2.vue?vue&type=style&index=0&id=8b901ae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports